import { TextButton } from '@creditornot/cb-button';
import { colors, typographyCss } from '@creditornot/cb-ingredients';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  categoryName: string;
  itemName: string;
  link: string;
  onUndo: () => void;
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const CategoryLink = styled(Link)`
  ${typographyCss.Body3};
  font-weight: 500;
  margin-block-start: 8px;
  margin-inline-end: 16px;
  color: ${colors.wolt100};

  &:hover {
    color: ${colors.wolt92};
  }
`;

const UndoButton = styled(TextButton).attrs({ size: 'small', variant: 'grey' })`
  margin-block-start: 8px;
`;

const CategoryChangeSuccessToast = ({ categoryName, itemName, link, onUndo }: Props) => {
  const [undoClicked, setUndoClicked] = useState(false);

  const handleUndoClick = () => {
    if (undoClicked === false) {
      onUndo();
      setUndoClicked(true);
    }
  };

  return (
    <Root>
      <div>
        <FormattedMessage
          id="menu.itemMoveToCategorySuccess"
          values={{ item: itemName, category: categoryName, bold: (text: string) => <b>{text}</b> }}
        />
      </div>
      <Actions>
        <CategoryLink to={link}>
          <FormattedMessage id="menu.goToCategory" values={{ category: categoryName }} />
        </CategoryLink>
        <UndoButton onClick={handleUndoClick}>
          <FormattedMessage id="state.undo" />
        </UndoButton>
      </Actions>
    </Root>
  );
};

export default CategoryChangeSuccessToast;
